module.exports = new __parcel__URL__("Priestskill_02.1307dcb2.png").toString();